// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-list-items {
  margin: 0;
  padding: 0;
}
.sidebar-list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
}
.sidebar-list-icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.user-dropdown {
  width: 200px !important;
}
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: red;
  width: 100%;
}
.sidebar-scroll {
  height: calc(90vh);
  overflow: auto;
  width: 250px;
}
.collapse {
  margin-left: 50px;
  padding: 0px;
}
.setup {
  margin-left: 0px;
}
.setup:hover {
  color: #2a8981;
  cursor: pointer;
}
.adminActivities {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}
.hide {
  display: none !important;
}
.sidebar-icon-only .sidebar-list-items {
  width: 50px;
}
.sidebar-icon-only .link-text,
.sidebar-icon-only .adminActivities {
  display: none;
}
.sidebar-icon-only .sidebar-scroll {
  width: 50px;
}
.sidebar-icon-only .collapse {
  margin-left: 0px;
}
.text-active {
  color: #2a8981 !important;
}
.zindex99 {
  z-index: 99 !important;
}
.right-side {
  transform: rotateY(180deg);
}

.left-side {
  transform: rotateY(0deg);
}
.nav-item {
  font-style: normal;
  font-size: 15px;
  color: black !important;
  font-family: Poppins;
}

/* styles.css */

/* Hide sidebar by default on mobile devices */
.sidebar-closed {
  display: none;
}

/* Show sidebar when the state is open */
.sidebar-open {
  display: block;
}

/* Ensure sidebar is visible on larger screens */
@media (min-width: 768px) {
  .sidebar-closed {
    display: block !important;
  }
  .btn-primary {
    display: none;
  }
}

/* Style the sidebar toggle button */
.btn-primary {
  z-index: 1050;
  border-radius: 50%;
  padding: 0.5rem;
  background-color: #007bff;
  color: white;
  border: none;
}

/* Sidebar styles */
.sidebar-scroll {
  transition: transform 0.3s ease;
}

/* Sidebar for large screens */
.d-md-block {
  display: block;
}

/* Styles for sidebar when open or closed on mobile */
.sidebar-open {
  transform: translateX(0);
  width: 220px; /* Adjust if needed */
}

.sidebar-closed {
  transform: translateX(-220px); /* Hides the sidebar */
}

/* Mobile styles */
@media (max-width: 844px) {
  .sidebar-open {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 220px;
    z-index: 999; /* Ensure it is above other content */
  }

  .sidebar-closed {
    display: none; /* Hide when closed */
  }
}

/* Desktop styles */
@media (min-width: 768px) {
  .sidebar-open {
    position: relative;
    transform: none; /* Reset transform for large screens */
  }

  .sidebar-closed {
    display: block; /* Show sidebar in default state */
    transform: none; /* Reset transform for large screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,eAAe;;AAEf,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;EACxB,YAAY,EAAE,qBAAqB;AACrC;;AAEA;EACE,6BAA6B,EAAE,sBAAsB;AACvD;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,YAAY,EAAE,qCAAqC;EACrD;;EAEA;IACE,aAAa,EAAE,qBAAqB;EACtC;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,kBAAkB;IAClB,eAAe,EAAE,sCAAsC;EACzD;;EAEA;IACE,cAAc,EAAE,kCAAkC;IAClD,eAAe,EAAE,sCAAsC;EACzD;AACF","sourcesContent":[".sidebar-list-items {\n  margin: 0;\n  padding: 0;\n}\n.sidebar-list-item {\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n}\n.sidebar-list-icon {\n  width: 15px;\n  height: 15px;\n  margin-right: 10px;\n}\n.user-dropdown {\n  width: 200px !important;\n}\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background-color: red;\n  width: 100%;\n}\n.sidebar-scroll {\n  height: calc(90vh);\n  overflow: auto;\n  width: 250px;\n}\n.collapse {\n  margin-left: 50px;\n  padding: 0px;\n}\n.setup {\n  margin-left: 0px;\n}\n.setup:hover {\n  color: #2a8981;\n  cursor: pointer;\n}\n.adminActivities {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n}\n.hide {\n  display: none !important;\n}\n.sidebar-icon-only .sidebar-list-items {\n  width: 50px;\n}\n.sidebar-icon-only .link-text,\n.sidebar-icon-only .adminActivities {\n  display: none;\n}\n.sidebar-icon-only .sidebar-scroll {\n  width: 50px;\n}\n.sidebar-icon-only .collapse {\n  margin-left: 0px;\n}\n.text-active {\n  color: #2a8981 !important;\n}\n.zindex99 {\n  z-index: 99 !important;\n}\n.right-side {\n  transform: rotateY(180deg);\n}\n\n.left-side {\n  transform: rotateY(0deg);\n}\n.nav-item {\n  font-style: normal;\n  font-size: 15px;\n  color: black !important;\n  font-family: Poppins;\n}\n\n/* styles.css */\n\n/* Hide sidebar by default on mobile devices */\n.sidebar-closed {\n  display: none;\n}\n\n/* Show sidebar when the state is open */\n.sidebar-open {\n  display: block;\n}\n\n/* Ensure sidebar is visible on larger screens */\n@media (min-width: 768px) {\n  .sidebar-closed {\n    display: block !important;\n  }\n  .btn-primary {\n    display: none;\n  }\n}\n\n/* Style the sidebar toggle button */\n.btn-primary {\n  z-index: 1050;\n  border-radius: 50%;\n  padding: 0.5rem;\n  background-color: #007bff;\n  color: white;\n  border: none;\n}\n\n/* Sidebar styles */\n.sidebar-scroll {\n  transition: transform 0.3s ease;\n}\n\n/* Sidebar for large screens */\n.d-md-block {\n  display: block;\n}\n\n/* Styles for sidebar when open or closed on mobile */\n.sidebar-open {\n  transform: translateX(0);\n  width: 220px; /* Adjust if needed */\n}\n\n.sidebar-closed {\n  transform: translateX(-220px); /* Hides the sidebar */\n}\n\n/* Mobile styles */\n@media (max-width: 844px) {\n  .sidebar-open {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 220px;\n    z-index: 999; /* Ensure it is above other content */\n  }\n\n  .sidebar-closed {\n    display: none; /* Hide when closed */\n  }\n}\n\n/* Desktop styles */\n@media (min-width: 768px) {\n  .sidebar-open {\n    position: relative;\n    transform: none; /* Reset transform for large screens */\n  }\n\n  .sidebar-closed {\n    display: block; /* Show sidebar in default state */\n    transform: none; /* Reset transform for large screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
